import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home.vue'
import Search from './views/search.vue'
import Spec from './views/spec.vue'
import Preview from './views/preview.vue'
import OrderList from './views/orderList.vue'
import DetailPrintOrder from './views/detailPrintOder.vue'
import Print from './views/print.vue'
import Tutorial from './views/tutorial.vue'
import Address from './views/address.vue'
import CustomerService from './views/customerService.vue'
import SavePhoto from './views/savePhoto.vue'


Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '证件照制作'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: {
        title: '搜索规格'
      }
    },
    {
      path: '/spec',
      name: 'spec',
      component: Spec,
      meta: {
        title: '规格详情'
      }
    },
		{
		  path: '/tutorial',
		  name: 'tutorial',
		  component: Tutorial,
		  meta: {
		    title: '教程'
		  }
		},
    {
      path: '/preview',
      name: 'preview',
      component: Preview,
    },

    {
      path: '/orderList',
      name: 'orderList',
      component: OrderList,
      meta: {
        title: '我的证件照'
      }
    },
    {
      path: '/detailPrintOrder',
      name: 'detailPrintOrder',
      component: DetailPrintOrder
    },
    {
      path: '/print',
      name: 'print',
      component: Print,
      meta: {
        title: '冲印'
      }
    },
		{
		  path: '/address',
		  name: 'address',
		  component: Address,
		  meta: {
		    title: '收货地址'
		  }
		},
		{
		  path: '/customerService',
		  name: 'customerService',
		  component: CustomerService,
		  meta: {
		    title: '收货地址'
		  }
		},
		{
		  path: '/savePhoto',
		  name: 'savePhoto',
		  component: SavePhoto,
		  meta: {
		    title: '保存电子照'
		  }
		},
		{
		  path:'*',
		  redirect: '/'
		},
  ]
})
